import {
  axiosAccess,
  axiosApplication,
  axiosDocument,
  axiosFile,
  axiosROW,
  axiosUser,
} from "@config/axiosConfig";

export const getCategoryList = async () => {
  return await axiosAccess.get("/application_category");
};

export const getAuthorityList = async () => {
  return await axiosAccess.get("/morth_auhtority");
};

export const getTypeOfProperty = async (category_id: number) => {
  return await axiosAccess.get(`/property_type/${category_id}`);
};

export const getLocationList = async () => {
  return await axiosAccess.get(`/location_list`);
};

export const getQuestionsList = async (
  category_id: number,
  location_id: number,
) => {
  return await axiosAccess.get(`/questions/${category_id}/${location_id}`);
};

export const postSubmitAmenitiesROW = async (payload: any) => {
  return await axiosROW.post(`/rowSubmit`, payload);
};

export const getDocumentsList = async (
  category_id: number,
  access_id: number | string,
  document: string,
) => {
  return await axiosDocument.get(
    `/${category_id}?application_id=${access_id}&document=${document}`,
  );
};

export const getFileUploadSignedUrl = async (
  fileName: string,
  fileSize: string,
  contentType: string,
  isEsign?: boolean,
) => {
  return await axiosFile.get(
    `/file-upload-signed-url?fileName=${fileName}&moduletype=row&fileSize=${fileSize}&contentType=${contentType}${isEsign ? `&isEsign=${isEsign}` : ""}`,
  );
};

export const getViewFileSignedUrl = async (
  document_name: string,
  folder?: "morth",
) => {
  return await axiosFile.get(
    `/get-file-signed-url?fileName=${document_name}&moduletype=row${
      folder === "morth" ? "&folder=morth" : ""
    }`,
  );
};

export const getDownloadSignedUrl = async (document_name: string) => {
  return await axiosFile.get(
    `/download-signed-url?fileName=${document_name}&moduletype=access`,
  );
};

export const getDeleteSignedUrl = async (fileName: string) => {
  return await axiosFile.get(
    `/delete-signed-url?fileName=${fileName}&moduletype=access`,
  );
};

export const getSignedUrlList = async () => {
  return await axiosFile.get(`/signed-url-list`);
};

export const postSavedUploadedFile = async (payload: any) => {
  return await axiosDocument.post(`/save-uploaded-file`, payload);
};

export const getUploadedFileById = async (
  access_id: number | string,
  category_id: number,
  document: string,
) => {
  return await axiosDocument.get(
    `/uploaded-files/${access_id}?module_type=row&application_type_id=${category_id}&document=${document}`,
  );
};

export const deleteFileById = async (
  access_id: number | string,
  document_id: number,
) => {
  return await axiosDocument.delete(`/delete/${access_id}/${document_id}`);
};

export const submitDocument = async (
  access_id: number | string,
  category_id: number,
) => {
  return await axiosDocument.get(
    `submit-document/${access_id}?application_type_id=${category_id}&module_type=row&document=file_upload`,
  );
};

// //delete file from aws
// export const deleteFileOnAwsAPI = async (payload) => {
//   return await axios.delete(payload.url);
// }
// ROW Flow

export const getRowUtilities = async () => {
  return await axiosROW.get(`/row-utilities`);
};

export const amenitiesROWUtility = async (utility_type_id: number) => {
  return await axiosROW.get(`/amenities?utility_type=${utility_type_id}`);
};

export const proposedUtilityAlignment = async () => {
  return await axiosROW.get("/proposed_utility");
};

export const submitSiteRoadwaysROW = async (payload: any) => {
  return await axiosROW.post(`/saveSiteInformation`, payload);
};

export const saveRowUndertaking = async (payload: any) => {
  return await axiosDocument.post("/submit-row-undertaking", payload);
};

export const postFinalLicense = async (payload: any) => {
  return await axiosUser.post(`/final-licence-request`, payload);
};

export const postFinalLicenseRow = async (payload: any) => {
  return await axiosApplication.post(`/final-license-row-request`, payload);
};

export const multiplePIUList = async (payload: any) => {
  return await axiosROW.post(`/passing-piu-ro-details`, payload);
};

export const utilityCrossingList = async () => {
  return await axiosROW.get(`/utility-crossing-list`);
};

export const postCircleRateUpdate = async (payload: any) => {
  return await axiosApplication.post(`/row-submit`, payload);
};

export const getSelectedStretch = async (payload: any) => {
  return await axiosUser.post(`/chanage-highlights`, payload);
};
